import {Component, OnInit} from '@angular/core';
import {LastActivityService} from '../../services/last-activity.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public lastActivity: string;

  constructor(private lastActivityService: LastActivityService) {

  }

  ngOnInit() {
    this.retriveLastActivity();
  }

  private retriveLastActivity() {
    this.lastActivityService.retrieve().subscribe(
      response => {
        console.log(response);
        this.lastActivity = response.lastActivity;
        console.log(this.lastActivity);
      },
      error => {
        console.log(error);
        this.lastActivity = 'Não foi possível recuperar a última atividade.';
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts